import { AppUtil } from 'kuaidong-lib'
import { DeliveryAddress, IDeliveryAddress, IDeliveryAddressForm } from 'kuaidong-model'

export class ADeliveryAddress {
  public static find(): Promise<DeliveryAddress> {
    return AppUtil.httpGET('/teacher/address')
  }

  public static save(form: DeliveryAddress) {
    return AppUtil.httpPUT('/teacher/address', form)
  }
}

export class ADeliveryAddressH5 {
  static find(): Promise<IDeliveryAddress> {
    return AppUtil.httpGET(`${process.env.VUE_APP_PAY_API}/payment/address`)
  }

  static save(form: IDeliveryAddressForm) {
    return AppUtil.httpPOST(`${process.env.VUE_APP_PAY_API}/payment/address/create_or_edit`, form)
  }

  static validate(form: IDeliveryAddressForm) {
    return AppUtil.httpPOST(`${process.env.VUE_APP_PAY_API}/payment/address/validate`, form)
  }

  static findByOrderId(orderId: string): Promise<IDeliveryAddress> {
    return AppUtil.httpGET(`${process.env.VUE_APP_PAY_API}/payment/order/address`, { order_id: orderId })
  }

  static saveByOrderId(orderId: string, form: IDeliveryAddressForm) {
    return AppUtil.httpPOST(`${process.env.VUE_APP_PAY_API}/payment/order/address`, { order_id: orderId, ...form })
  }
}
